export class Modules {
    id : number;
    typeOfEducationId : number;
    modulesName : string;
    modulesCode : string;
    displayOrder? : number;
}